import { WATERMARK_MAX_OUTPUT_WIDTH } from '../constants'

const getDownsizedWatermark = (source: File | string): Promise<Blob> =>
    new Promise((resolve, reject) => {
        const img = document.createElement('img')
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        img.onload = () => {
            const aspectRatio = img.naturalWidth / img.naturalHeight
            canvas.width = Math.min(img.naturalWidth, WATERMARK_MAX_OUTPUT_WIDTH)
            canvas.height = canvas.width / aspectRatio
            context?.drawImage(img, 0, 0, canvas.width, canvas.height)
            canvas.toBlob((blob) => {
                blob ? resolve(blob) : reject()
            }, 'image/png')
            if (typeof source !== 'string') {
                URL.revokeObjectURL(img.src)
            }
        }
        img.onerror = () => reject()
        img.crossOrigin = 'anonymous'
        img.src = typeof source === 'string' ? source : URL.createObjectURL(source)
    })

export default getDownsizedWatermark
